import React from "react";
import { formatMomentDate } from "../../../utils/dateHelper";
import StatusChip from "../../../components/statusChip/StatusChip";
import CustomTable from "../../../components/table/CustomTable";

const RequirementListSection = ({
    data,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    totalItems,
    isLoading,
    isInitialLoad,
    handleView,
    actionList
}) => {

    const getStatusBg = (status) => {
        const lowerStatus = status?.toLowerCase();
        switch (lowerStatus) {
            case "open":
                return "success";
            case "closed":
                return "secondary";
            default:
                return "";
        }
    };

    const pagination = {
        currentPage,
        totalPages: Math.ceil((totalItems || 0) / (pageSize || 10)),
        total: totalItems || 0,
        onPageChange: (page) => setCurrentPage(page),
        pageSize: pageSize || 10,
        setPageSize,
        setCurrentPage,
        perPageOptions: [10, 20, 50, 100],
    };

    const columns = [
        {
            id: "title",
            header: "TITLE",
            cell: (_, row) => (
                <span className="fw-medium text-nowrap">{row.title || "-"}</span>
            )
        },
        {
            id: "category",
            header: "CATEGORY",
            cell: (_, row) => (
                <span className="small text-nowrap">{row?.category?.name || "-"}</span>
            )
        },
        {
            id: "requester",
            header: "REQUESTER DETAILS",
            cell: (_, row) => {
                const requesterPhoto = row?.user?.profile?.profile_photo?.url;
                const requesterName = row?.user ? `${row.user.first_name} ${row.user.last_name}` : "-";
                return (
                    <div className="d-flex align-items-center gap-2">
                        {requesterPhoto ? (
                            <img src={requesterPhoto} alt="User" width={30} height={30} className="rounded-circle object-fit-cover" />
                        ) : (
                            <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 30, height: 30, fontSize: 10 }}>User</div>
                        )}
                        <div className="d-flex flex-column text-start">
                            <span className="fw-medium text-nowrap">{requesterName}</span>
                            <span className="text-secondary small">{row?.user?.mobile_number || "-"}</span>
                        </div>
                    </div>
                );
            }
        },
        {
            id: "state",
            header: "STATE",
            cell: (_, row) => (
                <span className="small text-nowrap">{row?.state?.name || "-"}</span>
            )
        },
        {
            id: "city",
            header: "CITY",
            cell: (_, row) => (
                <span className="small text-nowrap">{row?.city?.name || "-"}</span>
            )
        },
        {
            id: "status",
            header: "STATUS",
            cell: (_, row) => row?.status ? (
                <StatusChip
                    bg={getStatusBg(row.status)}
                    pill
                    title={row.status}
                    className="text-capitalize"
                />
            ) : "-"
        },
        {
            id: "created_at",
            header: "CREATED AT",
            cell: (_, row) => (
                <span className="small text-nowrap">
                    {row?.created_at ? formatMomentDate(row.created_at, "DD-MM-YYYY hh:mm A") : "-"}
                </span>
            )
        }
    ];

    return (
        <CustomTable
            data={data || []}
            columns={columns}
            loading={isLoading && !isInitialLoad}
            emptyMessage="No requirements found"
            keyField="id"
            pagination={pagination}
            actionList={actionList}
            rowClick={(row) => handleView && handleView(row)}
        />
    );
};

export default RequirementListSection;
